import { z } from "zod";

/**
 * Allowed group schema
 * Stores group metadata for display
 */
export const AllowedGroupSchema = z.object({
  id: z.string().uuid(), // Azure AD group ID
  displayName: z.string(),
  memberCount: z.number().optional() // Cached member count
});

export type AllowedGroup = z.infer<typeof AllowedGroupSchema>;
